import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";

const Terms = () => {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Navigation />
      <main className="pt-32 pb-24">
        <div className="container-luxury max-w-3xl">
          <h1 className="font-display text-3xl md:text-4xl tracking-wider text-foreground mb-16 text-center">
            Terms & Conditions
          </h1>

          <div className="space-y-10 font-body text-foreground/70 text-sm leading-[1.9]">
            <section>
              <h2 className="font-display text-foreground text-base tracking-wider mb-4">1. About ARZANI GROUP</h2>
              <p>1.1 Arzani Group Worldwide ("Arzani" or "the Company") operates as a luxury concierge and intermediary service provider.</p>
              <p className="mt-2">1.2 Arzani arranges and coordinates premium services on behalf of its clients across selected international destinations.</p>
              <p className="mt-2">1.3 By proceeding with a booking or making payment, the client agrees to these Terms & Conditions.</p>
            </section>

            <section>
              <h2 className="font-display text-foreground text-base tracking-wider mb-4">2. Nature of Services</h2>
              <p>2.1 Arzani arranges services including, but not limited to:</p>
              <ul className="list-disc list-inside mt-2 space-y-1 ml-4">
                <li>Yacht charters</li>
                <li>Luxury vehicle rentals</li>
                <li>Private villas and residences</li>
                <li>Chauffeur and VIP transport</li>
                <li>Restaurant and club reservations</li>
              </ul>
              <p className="mt-2">2.2 All services are provided by selected third-party partners.</p>
              <p className="mt-2">2.3 Arzani acts solely as an intermediary between the client and the respective third-party provider unless explicitly agreed otherwise in writing.</p>
              <p className="mt-2">2.4 Final service execution and operational responsibility remain with the third-party provider.</p>
            </section>

            <section>
              <h2 className="font-display text-foreground text-base tracking-wider mb-4">3. Reservations & Confirmations</h2>
              <p>3.1 A booking is only considered confirmed once the required deposit or full payment has been received.</p>
              <p className="mt-2">3.2 Availability of all services is subject to confirmation by the respective third-party provider.</p>
              <p className="mt-2">3.3 Arzani reserves the right to decline or cancel a booking request prior to confirmation without liability.</p>
            </section>

            <section>
              <h2 className="font-display text-foreground text-base tracking-wider mb-4">4. Yacht Reservations & Deposits</h2>
              <p>4.1 Yacht reservations may be held for a maximum period of twenty-four (24) hours without payment.</p>
              <p className="mt-2">4.2 If the required deposit is not received within this 24-hour period, Arzani reserves the right to release the reservation without further notice.</p>
              <p className="mt-2">4.3 A deposit is required to secure a yacht charter booking.</p>
              <p className="mt-2">4.4 If a yacht booking is cancelled on the same calendar day as the scheduled charter, the deposit is strictly non-refundable.</p>
              <p className="mt-2">4.5 Cancellation policies for other services may vary depending on the respective third-party provider and will be communicated at the time of booking.</p>
            </section>

            <section>
              <h2 className="font-display text-foreground text-base tracking-wider mb-4">5. Payments</h2>
              <p>5.1 Payment terms and deadlines will be communicated at the time of booking.</p>
              <p className="mt-2">5.2 Failure to complete payment within the agreed timeframe may result in cancellation of the reservation.</p>
              <p className="mt-2">5.3 All payments must be made using approved and agreed payment methods.</p>
            </section>

            <section>
              <h2 className="font-display text-foreground text-base tracking-wider mb-4">6. Pricing</h2>
              <p>6.1 Arzani aims to provide competitive and preferred rates across its destinations.</p>
              <p className="mt-2">6.2 Pricing remains subject to availability, seasonality, and third-party provider terms.</p>
              <p className="mt-2">6.3 Prices may change prior to booking confirmation.</p>
            </section>

            <section>
              <h2 className="font-display text-foreground text-base tracking-wider mb-4">7. Liability</h2>
              <p>7.1 Arzani acts solely as an intermediary and shall not be held responsible for the performance, actions, omissions, or service delivery of third-party providers.</p>
              <p className="mt-2">7.2 While Arzani carefully selects its partners, it shall not be liable for delays, damages, cancellations, accidents, injuries, losses, or service disruptions caused by third parties.</p>
              <p className="mt-2">7.3 To the maximum extent permitted by law, Arzani's liability shall be limited to the amount paid directly to Arzani for the arrangement of the specific service.</p>
              <p className="mt-2">7.4 Nothing in these Terms excludes liability for gross negligence or willful misconduct where such exclusion is not legally permitted.</p>
            </section>

            <section>
              <h2 className="font-display text-foreground text-base tracking-wider mb-4">8. Force Majeure</h2>
              <p>8.1 Arzani shall not be held responsible for failure or delay in performance due to circumstances beyond reasonable control.</p>
              <p className="mt-2">8.2 Such circumstances include, but are not limited to, adverse weather conditions, governmental restrictions, strikes, technical failures, or unforeseen operational disruptions.</p>
            </section>

            <section>
              <h2 className="font-display text-foreground text-base tracking-wider mb-4">9. Communication & Confidentiality</h2>
              <p>9.1 Arzani aims to remain available to its clients through designated communication channels.</p>
              <p className="mt-2">9.2 All client information and communications are handled with discretion and confidentiality.</p>
            </section>

            <section>
              <h2 className="font-display text-foreground text-base tracking-wider mb-4">10. Governing Law</h2>
              <p>10.1 These Terms & Conditions shall be governed by the laws applicable in the jurisdiction where Arzani Group Worldwide is registered.</p>
              <p className="mt-2">10.2 Any disputes arising from these Terms shall be subject to the exclusive jurisdiction of the competent courts in that jurisdiction.</p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Terms;